// Arabic is the source dictionary: its keys define MessageKey, and every
// English section must have exactly the same keys (the compiler checks).
import { core } from './locales/ar/core';
import { students } from './locales/ar/students';
import { payments } from './locales/ar/payments';
import { cash } from './locales/ar/cash';
import { fees } from './locales/ar/fees';
import { staff } from './locales/ar/staff';
import { advances } from './locales/ar/advances';
import { payroll } from './locales/ar/payroll';
import { settings } from './locales/ar/settings';
import { platform } from './locales/ar/platform';
import { attendance } from './locales/ar/attendance';
import { notes } from './locales/ar/notes';
import { academics } from './locales/ar/academics';
import { grading } from './locales/ar/grading';
import { announcements } from './locales/ar/announcements';
import { rollover } from './locales/ar/rollover';
import { imports } from './locales/ar/imports';

export const ar = {
  ...core,
  ...students,
  ...payments,
  ...cash,
  ...fees,
  ...staff,
  ...advances,
  ...payroll,
  ...settings,
  ...platform,
  ...attendance,
  ...notes,
  ...academics,
  ...grading,
  ...announcements,
  ...rollover,
  ...imports,
} as const;
